/**
 * Tire size form (finder + standalone shop-by-size).
 */
(function () {
  var RESULTS_PAGE = "/pages/tire-results";

  function digitsOnly(s) {
    return String(s || "").replace(/\D/g, "");
  }

  function normalizeSizeText(text) {
    return String(text || "")
      .replace(/[\u00A0\u200B-\u200D\uFEFF]/g, "")
      .trim();
  }

  function parsePastedSize(text) {
    var t = normalizeSizeText(text);
    if (!t) return null;
    var patterns = [
      /(\d{2,3})\s*[\/\-]\s*(\d{2})\s*R\s*(\d{1,2})\b/i,
      /(\d{2,3})\s*[\/\-]\s*(\d{2})\s*[\/\-]\s*(\d{1,2})\b/,
      /(\d{2,3})\s+(\d{2})\s+R?\s*(\d{1,2})\b/i,
    ];
    for (var i = 0; i < patterns.length; i++) {
      var m = t.match(patterns[i]);
      if (m) return { w: m[1], a: m[2], r: m[3] };
    }
    return null;
  }

  function validateTriple(w, a, r) {
    if (!w || !a || !r) {
      return "Enter width, aspect ratio, and rim diameter (all numbers).";
    }
    if (w.length < 2 || w.length > 3) {
      return "Section width should be 2–3 digits (e.g. 225).";
    }
    if (a.length !== 2) {
      return "Aspect ratio should be two digits (e.g. 60).";
    }
    if (r.length < 1 || r.length > 2) {
      return "Rim size should be one or two digits (e.g. 17).";
    }
    return "";
  }

  function initTireSizeForm(root) {
    if (!root || root.dataset.tsfInit === "1") return;
    root.dataset.tsfInit = "1";

    var form = root.querySelector("[data-tsf-form]");
    if (!form) return;

    var widthEl = root.querySelector('[data-tsf-field="width"]');
    var aspectEl = root.querySelector('[data-tsf-field="aspect"]');
    var rimEl = root.querySelector('[data-tsf-field="rim"]');
    var pasteEl = root.querySelector('[data-tsf-field="paste"]');
    var submitBtn = root.querySelector("[data-tsf-submit]");
    var pasteBtn = root.querySelector("[data-tsf-paste-btn]");
    var errEl = root.querySelector("[data-tsf-error]");
    var loadingEl = root.querySelector("[data-tsf-loading]");

    function showErr(msg) {
      if (!errEl) return;
      if (msg) {
        errEl.textContent = msg;
        errEl.hidden = false;
      } else {
        errEl.textContent = "";
        errEl.hidden = true;
      }
    }

    function setLoading(on) {
      if (loadingEl) loadingEl.hidden = !on;
      if (submitBtn) submitBtn.disabled = !!on;
      if (pasteBtn) pasteBtn.disabled = !!on;
    }

    function fillFields(w, a, r) {
      if (widthEl) widthEl.value = w;
      if (aspectEl) aspectEl.value = a;
      if (rimEl) rimEl.value = r;
    }

    function readTriple() {
      return {
        w: digitsOnly(widthEl && widthEl.value),
        a: digitsOnly(aspectEl && aspectEl.value),
        r: digitsOnly(rimEl && rimEl.value),
      };
    }

    function readTripleWithPasteFallback() {
      var t = readTriple();
      if (t.w && t.a && t.r) return t;
      var parsed = parsePastedSize(pasteEl && pasteEl.value);
      if (parsed) {
        fillFields(parsed.w, parsed.a, parsed.r);
        return parsed;
      }
      return t;
    }

    function navigateToSize(t) {
      var sizeParam = t.w + "-" + t.a + "-" + t.r;
      var summary = t.w + "/" + t.a + "R" + t.r;
      setLoading(false);

      if (root.dataset.tsfMode === "compare-browse") {
        window.dispatchEvent(
          new CustomEvent("specr:compare-browse-size", {
            detail: { sizeParam: sizeParam, label: summary },
          })
        );
        return;
      }

      var qs = "?size=" + encodeURIComponent(sizeParam);
      if (window.SpecrTireWizard && window.SpecrTireWizard.open) {
        window.SpecrTireWizard.open({ searchQuery: qs, summary: summary });
        return;
      }
      setLoading(true);
      if (window.SpecrTireProfile && window.SpecrTireProfile.appendProfileToQueryString) {
        qs = window.SpecrTireProfile.appendProfileToQueryString(qs);
      }
      window.location.href = RESULTS_PAGE + qs;
    }

    function goFind() {
      showErr("");
      var t = readTripleWithPasteFallback();
      var msg = validateTriple(t.w, t.a, t.r);
      if (msg) {
        showErr(msg);
        return;
      }
      navigateToSize(t);
    }

    function applyPaste() {
      showErr("");
      var parsed = parsePastedSize(pasteEl && pasteEl.value);
      if (!parsed) {
        showErr("Could not read size. Use format like 225/60R17 or 225/60/17.");
        return;
      }
      fillFields(parsed.w, parsed.a, parsed.r);
      var msg = validateTriple(parsed.w, parsed.a, parsed.r);
      if (msg) {
        showErr(msg);
        return;
      }
      navigateToSize(parsed);
    }

    if (submitBtn) submitBtn.addEventListener("click", goFind);
    if (pasteBtn) pasteBtn.addEventListener("click", applyPaste);
    if (pasteEl) {
      pasteEl.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          applyPaste();
        }
      });
    }
    [widthEl, aspectEl, rimEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
          e.preventDefault();
          goFind();
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll(".tire-size-fitment__root").forEach(initTireSizeForm);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
